<template>
    <div class="info-container">
        <apex-charts class="radial-chart" width="500" type="radialBar" :options="chartOptions" :series="progressValue" />
    </div>
</template>

<script>
    import ApexCharts from 'vue-apexcharts'
    export default {
        components: { ApexCharts },
        props: {
            progress: {
                type: Number,
                required: true
            },
            chartTitle: {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                progressValue: [],
                chartOptions: {
                    chart: {
                        type: 'radialBar'
                    },
                    plotOptions: {
                        radialBar: {
                            startAngle: -135,
                            endAngle: 135,
                            track: {
                                background: '#e7e7e7',
                                strokeWidth: '97',
                                margin: 5 // margin is in pixels
                            },
                            dataLabels: {
                                name: {
                                    show: true
                                },
                                value: {
                                    offsetY: 10,
                                    fontSize: '24px',
                                    color: '#00A65A'
                                }
                            }
                        }
                    },
                    fill: {
                        colors: ['#00A65A']
                    },
                    grid: {
                        padding: {
                            top: -10
                        }
                    },
                    labels: ['Progress'],
                    title: {
                        text: this.chartTitle
                    }
                }
            }
        },
        watch: {
            progress(newValue) {
                this.updateChart(newValue)
            }
        },
        created() {
            this.updateChart(this.progress)
        },
        methods: {
            updateChart(progressValue) {
                this.progressValue = [progressValue]
            }
        }
    }
</script>

<style>
.radial-chart .apexcharts-inner.apexcharts-graphical {
    transform: translateX(25px);
}
</style>
